import { windowService, documentService } from './window.utils';

function downloadFile(fileUrl: string, fileTitle?: string): void {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', fileUrl, true);
  xhr.responseType = 'blob';
  xhr.onload = function (): void {
    const urlCreator = windowService().URL || windowService().webkitURL;
    const fileObjectUrl = urlCreator.createObjectURL(this.response);
    const anchor = documentService().createElement('a');
    anchor.href = fileObjectUrl;
    anchor.download = fileTitle || '';
    documentService().body.appendChild(anchor);
    anchor.click();
    documentService().body.removeChild(anchor);
  };
  xhr.send();
}

export { downloadFile };
